import ReactQuill from "react-quill";

export const Editor = (props: EditorProps) => {
  let { content, onChange, modules, placeholder, className } = props;

  return (
    <ReactQuill
      theme="snow"
      className={`bg-white ${className || ""}`}
      modules={{ toolbar: modules }}
      value={content}
      onChange={onChange}
      placeholder={placeholder || ""}
    />
  );
};

export const defaultEditorModules: Array<Module> = [
  "bold",
  "italic",
  "underline",
  { list: "ordered" },
  { list: "bullet" },
];

export interface EditorProps {
  content: string;
  onChange: (content: string) => void;
  modules: Array<Module>;
  placeholder?: string;
  className?: string;
}

export type Module = string | { [key: string]: string };
